import { FC } from 'react';
import { Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { B2C } from 'cosmos-components';

import { useWindowDimensions } from 'src/hooks/useWindowDimensions';
import { DeviceType } from 'src/enums';
import globalMsg from 'src/messages';

import * as SShared from '../shared/products.form.style';

import { MODULE_PREFIX } from './extras.constants';
import * as S from './extras.form.style';
import { useExtrasForm } from './extras.hooks';

export const ExtrasForm: FC = () => {
    const intl = useIntl();
    const { isLoading, extras = {}, control, onSubmit } = useExtrasForm();
    const { deviceType } = useWindowDimensions();

    if (isLoading) {
        return <B2C.LoaderSpinner size="large" />;
    }

    const extrasAsSortedArray = Object.keys(extras)
        .map((extraKey) => extras[extraKey])
        .sort((e1, e2) => e1.order - e2.order);

    return (
        <SShared.StyledForm onSubmit={onSubmit}>
            {extrasAsSortedArray.length > 0 ? (
                extrasAsSortedArray.map((extraCategory) => (
                    <S.CategoryContainer
                        key={`${extraCategory.code}-container`}
                    >
                        <h3>{extraCategory.name}</h3>
                        <S.ExtraContainer>
                            {extraCategory.products
                                .filter((product) => !product.isPartnerProduct)
                                .map((product) => (
                                    <Controller
                                        name={`${product.id.productId}`}
                                        control={control}
                                        key={`${product.name}-extraCard`}
                                        render={({ field }) => (
                                            <B2C.ExtraCard
                                                title={product.name}
                                                description={
                                                    product.description ?? ''
                                                }
                                                minQuantity={
                                                    product.minQuantity
                                                }
                                                maxQuantity={
                                                    product.maxQuantity
                                                }
                                                requiresQuantity={
                                                    product.requiresQuantity
                                                }
                                                price={product.price}
                                                loading={product.isLoading}
                                                prepaid={product.prepaid}
                                                included={product.included}
                                                isMobile={
                                                    deviceType ===
                                                    DeviceType.Mobile
                                                }
                                                input={{
                                                    ...field,
                                                    disabled:
                                                        !!product.isDisabled,
                                                }}
                                            />
                                        )}
                                    />
                                ))}
                        </S.ExtraContainer>
                    </S.CategoryContainer>
                ))
            ) : (
                <div>No result</div>
            )}
            <SShared.ActionWrapper>
                <SShared.StyledPrimaryButton
                    data-test-id={`${MODULE_PREFIX}-save`}
                    type="submit"
                >
                    {intl.formatMessage(globalMsg.buttons.continue)}
                </SShared.StyledPrimaryButton>
            </SShared.ActionWrapper>
        </SShared.StyledForm>
    );
};
